import { Pipe, PipeTransform } from '@angular/core';

import { DateTime } from 'luxon';

/**
 * Get the duraton between start date and end date in minutes
 *
 * __Usage :__
 *   startDate | ngxDuration: endDate
 *
 * __Example :__
 *   {{ 2017-08-27T16:30:00.000Z | ngxDuration: 2017-08-27T17:30:00.000Z }}
 *   formats to: 60
 *
 * Module {@link TransformDurationToTextModule}
 */
@Pipe({
    name: 'ngxDuration'
})

export class TransformDurationPipe implements PipeTransform {
    transform(startDate: string, endDate: string): number {
        let diffs = 0;

        if (startDate && endDate) {

            const endTime = DateTime.fromISO(endDate);
            const start = DateTime.fromISO(startDate);
            diffs = endTime.diff(start, ['minutes']).toObject().minutes;

            if (diffs < 0 || typeof diffs === 'undefined') diffs = 0;
        }

        return diffs;
    }
}
